/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface AncillarySupplierListItem
 */
export interface AncillarySupplierListItem {
    /**
     * 
     * @type {string}
     * @memberof AncillarySupplierListItem
     */
    id?: string;
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof AncillarySupplierListItem
     */
    supplier?: GuidIdAndLabel;
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof AncillarySupplierListItem
     */
    carrier?: GuidIdCodeAndLabel;
    /**
     * 
     * @type {Int32IdAndLabel}
     * @memberof AncillarySupplierListItem
     */
    ancillaryCategory?: Int32IdAndLabel;
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof AncillarySupplierListItem
     */
    ancillary?: GuidIdAndLabel;
    /**
     * 
     * @type {string}
     * @memberof AncillarySupplierListItem
     */
    ancillarySupplierCode?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AncillarySupplierListItem
     */
    allowEdit?: boolean;
}

export function AncillarySupplierListItemFromJSON(json: any): AncillarySupplierListItem {
    return AncillarySupplierListItemFromJSONTyped(json, false);
}

export function AncillarySupplierListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): AncillarySupplierListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'supplier': !exists(json, 'supplier') ? undefined : GuidIdAndLabelFromJSON(json['supplier']),
        'carrier': !exists(json, 'carrier') ? undefined : GuidIdCodeAndLabelFromJSON(json['carrier']),
        'ancillaryCategory': !exists(json, 'ancillaryCategory') ? undefined : Int32IdAndLabelFromJSON(json['ancillaryCategory']),
        'ancillary': !exists(json, 'ancillary') ? undefined : GuidIdAndLabelFromJSON(json['ancillary']),
        'ancillarySupplierCode': !exists(json, 'ancillarySupplierCode') ? undefined : json['ancillarySupplierCode'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
    };
}

export function AncillarySupplierListItemToJSON(value?: AncillarySupplierListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'supplier': GuidIdAndLabelToJSON(value.supplier),
        'carrier': GuidIdCodeAndLabelToJSON(value.carrier),
        'ancillaryCategory': Int32IdAndLabelToJSON(value.ancillaryCategory),
        'ancillary': GuidIdAndLabelToJSON(value.ancillary),
        'ancillarySupplierCode': value.ancillarySupplierCode,
        'allowEdit': value.allowEdit,
    };
}


